import axios from "axios";
import React, { useEffect, useRef, useState, useContext } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import { timer } from "rxjs";
import OrderBook from "./OrderBook";
import { showToast, WEBSERVICE } from "../../CoreDataService";
import { DataContext } from ".";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import { useTradingColors } from "./tradingColorConfig";

const formatAssetItem = (asset) => {
  const isRocPositive = Number(asset?.roc) > 0;
  const ltpColor =
    asset?.action === "buy"
      ? true
      : asset?.action === "sell"
        ? false
        : null;

  return {
    currencycode: asset?.currencyCode,
    basecurrency: asset?.baseCurrency,
    lasttrade1: asset?.ltpValue,
    lasttrade2: asset?.ltpConvValue,
    lpricecolor: ltpColor,
    roc: Number(asset?.roc) || 0,
    volume: asset?.volume,
    isRocPositive: isRocPositive,
    amountPrecision: asset?.amountPrecision,
    pricePrecision: asset?.pricePrecision,
    assetCode: asset?.assetCode,
    currencyType: asset?.currencyType,
  };
};

const LeftTable = () => {
  const { setCurrencycode, setBasecurrency, currencycode, basecurrency } =
    useContext(DataContext);
  const theme = localStorage.getItem("theme");
  const { brokerBasicInfo, btncolor } = useSelector((state) => state);
  const { pairButtonColor, upColor, downColor } = useTradingColors();
  const [show, setShow] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [selected, setSelected] = useState(
    currencycode && basecurrency
      ? `${currencycode.toUpperCase()}/${basecurrency.toUpperCase()}`
      : ""
  );
  const [currency, setCurrency] = useState("BTC");
  const [filterCurrency, setFilterCurrency] = useState([]);
  const [dropdownFiatList, setDropdownFiatList] = useState([]);
  const [assetetpair, setAssetetpair] = useState([]);
  const [assetetpairback, setAssetetpairback] = useState([]);
  const [assetetpairbackOrigin, setAssetetpairbackOriginal] = useState([]);
  const [roccolor, setRoccolor] = useState(false);
  const [ltpcolor, setLtpcolor] = useState(null);
  const [sort, setSort] = useState(false);

  const [showFiat, setShowFiat] = useState(false);
  const [fiatSelected, setFiatSelected] = useState("FIAT");
  const [searchTerm, setSearchTerm] = useState("");
  const [allPairs, setAllPairs] = useState(() => {
    try {
      const cached = localStorage.getItem("spot_assets");
      return cached ? JSON.parse(cached).map(formatAssetItem) : [];
    } catch (e) {
      return [];
    }
  });
  const allPairsRef = useRef(allPairs);

  const [favoritePairs, setFavoritePairs] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("favorite_pairs") || "[]");
    } catch (e) {
      return [];
    }
  });

  const toggleFavoritePair = (item, e) => {
    if (e) e.stopPropagation();
    try {
      const key = `${item.currencycode}_${item.basecurrency}`.toUpperCase();
      let favs = JSON.parse(localStorage.getItem("favorite_pairs") || "[]");
      const exists = favs.some((f) => f.toUpperCase() === key || f.toUpperCase() === `${item.currencycode}/${item.basecurrency}`.toUpperCase());
      if (exists) {
        favs = favs.filter(
          (f) => f.toUpperCase() !== key && f.toUpperCase() !== `${item.currencycode}/${item.basecurrency}`.toUpperCase()
        );
      } else {
        favs.push(key);
      }
      localStorage.setItem("favorite_pairs", JSON.stringify(favs));
      setFavoritePairs(favs);
      window.dispatchEvent(new Event("favorite_pairs_updated"));

      if (currency === "FAVORITES") {
        const pool = allPairsRef.current?.length > 0 ? allPairsRef.current : allPairs;
        const favFiltered = pool.filter((it) => {
          const k1 = `${it.currencycode}_${it.basecurrency}`.toUpperCase();
          const k2 = `${it.currencycode}/${it.basecurrency}`.toUpperCase();
          return favs.some((f) => f.toUpperCase() === k1 || f.toUpperCase() === k2);
        });
        setAssetetpair(favFiltered);
        setAssetetpairbackOriginal([...favFiltered]);
        setAssetetpairback([...favFiltered]);
      }
    } catch (err) {
      console.error("Error toggling favorite pair:", err);
    }
  };

  const isPairFavorite = (item) => {
    if (!item) return false;
    const k1 = `${item.currencycode}_${item.basecurrency}`.toUpperCase();
    const k2 = `${item.currencycode}/${item.basecurrency}`.toUpperCase();
    return favoritePairs.some((f) => f.toUpperCase() === k1 || f.toUpperCase() === k2);
  };

  useEffect(() => {
    const handleFavUpdated = () => {
      try {
        const favs = JSON.parse(localStorage.getItem("favorite_pairs") || "[]");
        setFavoritePairs(favs);
        if (currency === "FAVORITES") {
          const pool = allPairsRef.current?.length > 0 ? allPairsRef.current : allPairs;
          const favFiltered = pool.filter((it) => {
            const k1 = `${it.currencycode}_${it.basecurrency}`.toUpperCase();
            const k2 = `${it.currencycode}/${it.basecurrency}`.toUpperCase();
            return favs.some((f) => f.toUpperCase() === k1 || f.toUpperCase() === k2);
          });
          setAssetetpair(favFiltered);
          setAssetetpairbackOriginal([...favFiltered]);
          setAssetetpairback([...favFiltered]);
        }
      } catch (e) {}
    };

    window.addEventListener("favorite_pairs_updated", handleFavUpdated);
    return () => {
      window.removeEventListener("favorite_pairs_updated", handleFavUpdated);
    };
  }, [currency, allPairs]);

  useEffect(() => {
    allPairsRef.current = allPairs;
  }, [allPairs]);

  const [newFiatArray, setNewFiatArray] = useState(() => {
    try {
      const cached = localStorage.getItem("user_fiat_array");
      return cached ? JSON.parse(cached) : [];
    } catch (e) {
      return [];
    }
  });
  const [loading, setLoading] = useState(true);

  const handleClose = () => setShow(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        !event.target.closest(".currency_Container")
      ) {
        setSearchTerm("");
        setAssetetpairback(assetetpairbackOrigin);
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, assetetpairbackOrigin]);

  const handleToggle = () => {
    if (isOpen) {
      setSearchTerm("");
      setAssetetpairback(assetetpairbackOrigin);
    }
    setIsOpen(!isOpen);
  };
  const handleSelect = (data) => {
    setSelected(data);
    setIsOpen(!isOpen);
  };

  // useEffect(() => {
  //   const storedTradeP = localStorage.getItem("tradep");
  //   if (storedTradeP) {
  //     setTradep(parseInt(storedTradeP));
  //   }
  // }, []);

  useEffect(() => {
    if (currencycode && basecurrency) {
      setSelected(`${currencycode.toUpperCase()}/${basecurrency.toUpperCase()}`);
    }
  }, [currencycode, basecurrency]);

  useEffect(() => {
    setSelected(`${currencycode.toUpperCase()}/${basecurrency.toUpperCase()}`);

    getNewCurrency();
    getUserBalance();
  }, []);

  const getUserBalance = () => {
    const userTransObj = {
      customerId: localStorage.getItem("userId"),
      uuid: localStorage.getItem("uuid"),
    };

    const jsonString = JSON.stringify(userTransObj);

    axios
      .post(`${WEBSERVICE}transaction/getUserBalance`, jsonString, {
        headers: {
          "Content-Type": "application/json",
          authorization: "BEARER " + localStorage.getItem("access_token"),
        },
      })
      .then((response) => {
        const result = response.data;
        const userBalanceList = result.userBalanceList;

        if (userBalanceList != null) {
          console.log("new fiat data all pairs", userBalanceList);

          const fiatCurrencies = userBalanceList
            .filter((item) => item.currencyType === 1)
            .map((item) => item.currencyCode);

          setNewFiatArray(fiatCurrencies);
          localStorage.setItem("user_fiat_array", JSON.stringify(fiatCurrencies));
          window.dispatchEvent(
            new CustomEvent("user_fiat_array_updated", { detail: fiatCurrencies })
          );
          console.log("new fiat data", fiatCurrencies);
        }

        if (result.error?.error_data !== 0) {
          // data.alert('Cannot fetch user balance', 'danger');
        }
      })
      .catch((error) => {
        // if (error.response?.status === 401 || error.response?.status === 400) {
        //   //logout
        //   showToast("error", "SESSION TIMED OUT. LOGIN AGAIN");
        // } else if (![200, 429, 403].includes(error.response?.status)) {
        //   // data.alert(error.message, 'warning');
        // }
      });
  };

  const getNewCurrency = async (currency = "BTC") => {
    setCurrency(currency);
    setLoading(true);
    try {
      const response = await axios.get(
        `https://accounts.paybito.com/CacheService/api/getAssetsData?Name=Assets&BrokerId=${localStorage.getItem(
          "BROKERID"
        )}`
      );

      const filterCurrencyData = JSON.parse(response.data.value);
      localStorage.setItem(
        "spot_assets",
        JSON.stringify(filterCurrencyData.Values)
      );
      if (filterCurrencyData.Header && Array.isArray(filterCurrencyData.Header)) {
        localStorage.setItem("spot_headers", JSON.stringify(filterCurrencyData.Header));
      }

      console.log("filterCurrencyData", filterCurrencyData);

      setFilterCurrency(filterCurrencyData);
      const assets = filterCurrencyData.Values || [];

      const basecur = assets.filter(
        (x) => x.baseCurrency === "USDT" && x.currencyCode === "BTC"
      );

      const fiat1 = assets.filter((x) => x.currencyType === 1);
      const fiat2 = [...new Set(fiat1.map((item) => item.baseCurrency))];

      setDropdownFiatList(fiat2);

      // Find the active asset based on the current currencycode and basecurrency
      const activeAsset = assets.find(
        (x) =>
          x.currencyCode?.toUpperCase() === currencycode?.toUpperCase() &&
          x.baseCurrency?.toUpperCase() === basecurrency?.toUpperCase()
      );

      if (activeAsset) {
        localStorage.setItem("amountprc", activeAsset.amountPrecision);
        localStorage.setItem("priceprc", activeAsset.pricePrecision);
        localStorage.setItem("assetCode", activeAsset.assetCode);
      } else {
        // Fallback to basecur[0] if activeAsset is not found
        if (basecur && basecur.length > 0) {
          localStorage.setItem("amountprc", basecur[0].amountPrecision);
          localStorage.setItem("priceprc", basecur[0].pricePrecision);
          localStorage.setItem("assetCode", basecur[0].assetCode);
        } else {
          localStorage.setItem("amountprc", "6");
          localStorage.setItem("priceprc", "6");
        }
      }

      const allMapped = assets.map(formatAssetItem);
      setAllPairs(allMapped);
      allPairsRef.current = allMapped;

      const basrcurrency = currency;
      const newAssetetpair = [];
      if (basrcurrency === "FAVORITES") {
        const favList = JSON.parse(localStorage.getItem("favorite_pairs") || "[]");
        allMapped.forEach((item) => {
          const k1 = `${item.currencycode}_${item.basecurrency}`.toUpperCase();
          const k2 = `${item.currencycode}/${item.basecurrency}`.toUpperCase();
          if (favList.some((f) => f.toUpperCase() === k1 || f.toUpperCase() === k2)) {
            newAssetetpair.push(item);
          }
        });
      } else {
        allMapped.forEach((item) => {
          if (basrcurrency === item.basecurrency) {
            newAssetetpair.push(item);
          } else if (basrcurrency === "ALL") {
            if (
              item.currencyType === 1 &&
              newFiatArray.includes(item.basecurrency) === true
            ) {
              newAssetetpair.push(item);
            }
          } else if (basrcurrency === "OTHER") {
            if (
              !["AED", "USD", "INR", "ETH", "BTC"].includes(item.basecurrency)
            ) {
              newAssetetpair.push(item);
            }
          }
        });
      }

      setAssetetpair(newAssetetpair);
      setAssetetpairbackOriginal([...newAssetetpair]);

      if (searchTerm.trim() !== "") {
        filterAcrossAllPairs(searchTerm, allMapped);
      } else {
        setAssetetpairback([...newAssetetpair]);
      }

      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.error("Error fetching asset data", error);
    }
  };

  const handleCurrencySelect = (d) => {
    setSelected(`${d?.currencycode}/${d?.basecurrency}`);
    setCurrencycode(d?.currencycode);
    setBasecurrency(d?.basecurrency);
    localStorage.setItem("buying_crypto_asset", d?.currencycode);
    localStorage.setItem("selling_crypto_asset", d?.basecurrency);
    setSearchTerm("");
    setIsOpen(false);
  };

  const filterAcrossAllPairs = (searchText, customPool = null) => {
    const rawQuery = (searchText || "").trim();
    if (!rawQuery) {
      setAssetetpairback(assetetpairbackOrigin);
      return;
    }

    const query = rawQuery.toUpperCase();
    const cleanQuery = query.replace(/[\/\-_ ]/g, "");
    const pool =
      customPool ||
      (allPairsRef.current?.length > 0 ? allPairsRef.current : allPairs);

    if (!pool || pool.length === 0) {
      setAssetetpairback([]);
      return;
    }

    const hasDelimiter = /[\/\-_ ]/.test(query);
    const parts = query.split(/[\/\-_ ]+/).filter(Boolean);

    let filtered = [];

    if (hasDelimiter && parts.length >= 2) {
      const counterPart = parts[0];
      const basePart = parts[1];

      filtered = pool.filter((item) => {
        const cCode = (item?.currencycode || "").toUpperCase();
        const bCode = (item?.basecurrency || "").toUpperCase();

        const counterMatches =
          cCode === counterPart || cCode.startsWith(counterPart);

        let baseMatches = false;
        if (["USD", "PUSD", "USDT", "USDC"].includes(basePart)) {
          baseMatches = bCode === basePart;
        } else {
          baseMatches = bCode === basePart || bCode.startsWith(basePart);
        }

        return counterMatches && baseMatches;
      });
    } else if (hasDelimiter && parts.length === 1) {
      const token = parts[0];
      const isLeadingDelimiter = /^[\/\-_ ]/.test(query);

      filtered = pool.filter((item) => {
        const cCode = (item?.currencycode || "").toUpperCase();
        const bCode = (item?.basecurrency || "").toUpperCase();

        if (isLeadingDelimiter) {
          if (["USD", "PUSD", "USDT", "USDC"].includes(token)) {
            return bCode === token;
          }
          return bCode === token || bCode.startsWith(token);
        } else {
          return cCode === token || cCode.startsWith(token);
        }
      });
    } else {
      // Single token search (e.g. "USD", "PUSD", "BTC", "BTCUSD", "USDT", etc.)
      if (cleanQuery === "USD") {
        filtered = pool.filter((item) => {
          const cCode = (item?.currencycode || "").toUpperCase();
          const bCode = (item?.basecurrency || "").toUpperCase();
          return bCode === "USD" || cCode === "USD";
        });
      } else if (cleanQuery === "PUSD") {
        filtered = pool.filter((item) => {
          const cCode = (item?.currencycode || "").toUpperCase();
          const bCode = (item?.basecurrency || "").toUpperCase();
          return bCode === "PUSD" || cCode === "PUSD";
        });
      } else if (cleanQuery === "USDT") {
        filtered = pool.filter((item) => {
          const cCode = (item?.currencycode || "").toUpperCase();
          const bCode = (item?.basecurrency || "").toUpperCase();
          return bCode === "USDT" || cCode === "USDT";
        });
      } else if (cleanQuery === "USDC") {
        filtered = pool.filter((item) => {
          const cCode = (item?.currencycode || "").toUpperCase();
          const bCode = (item?.basecurrency || "").toUpperCase();
          return bCode === "USDC" || cCode === "USDC";
        });
      } else {
        filtered = pool.filter((item) => {
          const cCode = (item?.currencycode || "").toUpperCase();
          const bCode = (item?.basecurrency || "").toUpperCase();
          const pairCombined = `${cCode}${bCode}`;
          const pairWithSlash = `${cCode}/${bCode}`;

          // Exact combined pair match (e.g. "BTCUSD" matches BTC/USD, "BTCPUSD" matches BTC/PUSD)
          if (pairCombined === cleanQuery) {
            return true;
          }

          if (pairWithSlash.includes(query)) {
            return true;
          }

          if (
            cCode === cleanQuery ||
            cCode.startsWith(cleanQuery) ||
            cCode.includes(cleanQuery)
          ) {
            return true;
          }

          if (bCode === cleanQuery || bCode.startsWith(cleanQuery)) {
            return true;
          }

          // Combined pair starts with query (e.g., user is typing "BTCU...")
          if (pairCombined.startsWith(cleanQuery)) {
            // Guard against "USD" substring matching USDT/USDC/PUSD
            if (
              cleanQuery.endsWith("USD") &&
              (bCode === "USDT" || bCode === "USDC" || bCode === "PUSD")
            ) {
              return false;
            }
            return true;
          }

          return false;
        });
      }
    }

    const ranked = [...filtered].sort((a, b) => {
      const aC = (a?.currencycode || "").toUpperCase();
      const aB = (a?.basecurrency || "").toUpperCase();
      const bC = (b?.currencycode || "").toUpperCase();
      const bB = (b?.basecurrency || "").toUpperCase();

      const getScore = (c, base) => {
        const pairComb = `${c}${base}`;
        if (pairComb === cleanQuery) return 100;
        if (c === cleanQuery) return 90;
        if (base === cleanQuery) return 80;
        if (c.startsWith(cleanQuery)) return 70;
        if (base.startsWith(cleanQuery)) return 60;
        if (c.includes(cleanQuery)) return 50;
        return 10;
      };

      return getScore(bC, bB) - getScore(aC, aB);
    });

    setAssetetpairback(ranked);
  };

  const handleSearch = (searchText) => {
    setSearchTerm(searchText);
    filterAcrossAllPairs(searchText);
  };

  const handleVolumnToggle = () => {
    if (sort) {
      const sortData = [...assetetpairback].sort(
        (a, b) => Number(a?.volume || 0) - Number(b?.volume || 0)
      );
      setAssetetpairback(sortData);
      setSort(false);
    } else {
      const sortData = [...assetetpairback].sort(
        (a, b) => Number(b?.volume || 0) - Number(a?.volume || 0)
      );
      setAssetetpairback(sortData);
      setSort(true);
    }
  };
  const handleSelectFiat = (text) => {
    setFiatSelected(text);
    setShowFiat(false);
  };

  const websocket = {
    stompClient: null,
    unsubscribe: () => console.log("Unsubscribed"),
    _disconnect: () => console.log("WebSocket Disconnected"),
    _connect: () => console.log("WebSocket Connected"),
    subscribe: () => console.log("WebSocket Subscribed"),
  };

  const trade = {
    reload: () => console.log("Trade reloaded"),
    myTradeDisplay: (value) => console.log("My Trade Display: ", value),
  };

  const callTradeHistory = (action) =>
    console.log("Trade History called with action: ", action);

  const setTradeData = (updateFunction) =>
    console.log("Trade Data Updated", updateFunction);

  const buySellCode = (item) => {
    let previousCurrency =
      localStorage.getItem("buying_crypto_asset")?.toUpperCase() || "";
    let previousBaseCurrency =
      localStorage.getItem("selling_crypto_asset")?.toUpperCase() || "";

    if (item.currencycode === "BTC" && item.basecurrency === "USD") {
      websocket.unsubscribe();
      websocket._disconnect();
    } else if (previousCurrency === "BTC" && previousBaseCurrency === "USD") {
      websocket.unsubscribe();
      websocket._disconnect();
    } else {
      websocket.unsubscribe();
    }

    if (websocket.stompClient !== null) {
      setTimeout(() => {
        if (item.currencycode === "BTC" && item.basecurrency === "USD") {
          websocket?._connect();
        } else if (
          previousCurrency === "BTC" &&
          previousBaseCurrency === "USD"
        ) {
          websocket?._connect();
        } else {
          websocket?.subscribe();
        }
      }, 1000);
    }

    setTradeData((prev) => {
      const updatedData = { ...prev };
      updatedData.selectedSellingAssetText = item.basecurrency;
      updatedData.selectedBuyingAssetText = item.currencycode;
      updatedData.selectedBuyingCryptoCurrencyName =
        item.basecurrency + item.currencycode;
      updatedData.selectedSellingCryptoCurrencyName =
        item.currencycode + item.basecurrency;
      updatedData.selectedSellingCryptoCurrencyissuer = "";
      updatedData.selectedBuyingCryptoCurrencyissuer = "";
      return updatedData;
    });

    localStorage.setItem(
      "buying_crypto_asset",
      item.currencycode.toLowerCase()
    );
    localStorage.setItem(
      "selling_crypto_asset",
      item.basecurrency.toLowerCase()
    );
    localStorage.setItem("amountprc", item.amountPrecision);
    localStorage.setItem("priceprc", item.pricePrecision);
    localStorage.setItem("assetCode", item.assetCode);
    localStorage.setItem("isAssetPairChangedRecently", "true");
    localStorage.setItem("isResetTheStoplossfieldForSpot", "true");

    let assetChangeCounter = localStorage.getItem("assetChangeCounterForSpot");
    if (assetChangeCounter) {
      assetChangeCounter = parseInt(assetChangeCounter) + 1;
    } else {
      assetChangeCounter = 1;
    }
    localStorage.setItem("assetChangeCounterForSpot", assetChangeCounter);

    setSelected(`${item.currencycode.toUpperCase()}/${item.basecurrency.toUpperCase()}`);
    setCurrencycode(item.currencycode);
    setBasecurrency(item.basecurrency);
    setSearchTerm("");

    trade.reload();
    trade.myTradeDisplay(0);

    callTradeHistory("click");

    document.getElementById("trade")?.click();
    // document.getElementById("dropHolder").style.overflow = "scroll";

    window.addEventListener("resize", () => {
      const wd = document.getElementById("chartHolder")?.offsetWidth;
      if (wd) {
        document.getElementById("dropHolder").style.width = `${wd}px`;
        document.getElementById("dropHolder").style.overflow = "scroll";
      }
    });

    setIsOpen(false);
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%", width: "100%", flex: 1, minHeight: 0, position: "relative" }}>
      <div
        className="currency_Container tour1"
        style={{
          backgroundColor: pairButtonColor || btncolor,
          flexShrink: 0,
        }}
      >
        <p
          className="currency_text d-flex align-items-center justify-content-center"
          onClick={handleToggle}
        >
          {selected ||
            (currencycode && basecurrency
              ? `${currencycode.toUpperCase()}/${basecurrency.toUpperCase()}`
              : "")}
          {isOpen ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
        </p>
      </div>
      {isOpen && (
        <div
          ref={dropdownRef}
          className="dropdown_"
          style={{
            backgroundColor: "var(--body-color)",
            position: "absolute",
            top: "38px",
            left: 0,
            width: "500px",
            maxWidth: "92vw",
            zIndex: 1200,
            boxShadow: "0 14px 40px rgba(0, 0, 0, 0.7)",
            border: "1px solid rgba(125, 125, 125, 0.25)",
            borderRadius: "8px",
            padding: "8px",
          }}
        >
          <div
            className="search_container"
            tabIndex="0"
            style={{
              margin: "5px",
              display: "flex",
              alignItems: "center",
              position: "relative",
            }}
          >
            <i className="fa-solid fa-magnifying-glass"></i>
            <input
              type="text"
              placeholder="Search"
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
              style={{ flex: 1 }}
            />
            {searchTerm && (
              <i
                className="fa-solid fa-xmark"
                style={{
                  cursor: "pointer",
                  padding: "0 6px",
                  color: "var(--text-color)",
                  opacity: 0.7,
                }}
                onClick={() => handleSearch("")}
              ></i>
            )}
          </div>
          <div
            className="currency_ d-flex justify-content-around align-items-center"
            style={{ marginTop: "5px" }}
          >
            <p
              onClick={() => {
                setSearchTerm("");
                getNewCurrency("FAVORITES");
              }}
              style={{
                cursor: "pointer",
                fontSize: "16px",
                color: currency === "FAVORITES" ? "#f0b90b" : "var(--text-color)",
                fontWeight: currency === "FAVORITES" ? 700 : 500,
                display: "inline-flex",
                alignItems: "center",
                padding: "2px 4px",
                borderBottom: currency === "FAVORITES" ? "2px solid #f0b90b" : "none",
              }}
              title="Favorite Pairs"
            >
              ★
            </p>
            {filterCurrency?.Header?.length !== 0 &&
              filterCurrency?.Header?.map((data, i) => (
                <p
                  key={i}
                  onClick={() => {
                    setSearchTerm("");
                    getNewCurrency(data);
                  }}
                  style={{
                    cursor: "pointer",
                    fontSize: "16px",
                    color: currency === data ? (pairButtonColor || "#1976d2") : "var(--text-color)",
                    fontWeight: currency === data ? 700 : 500,
                    borderBottom: currency === data ? `2px solid ${pairButtonColor || "#1976d2"}` : "none",
                  }}
                >
                  {data}
                </p>
              ))}
            {/* <p onClick={() => setShowFiat(!showFiat)}>{fiatSelected}</p> */}
            <Dropdown
              style={{
                backgroundColor: "var(--body-color-less)",
                border: "none",
              }}
            >
              <Dropdown.Toggle
                id="dropdown-basic"
                style={{
                  backgroundColor: "var(--body-color-less)",
                  color: "var(--text-color)",
                  border: "none",
                }}
              >
                {fiatSelected}
              </Dropdown.Toggle>

              <Dropdown.Menu
                style={{
                  maxHeight: "200px",
                  overflowY: "scroll",
                  scrollbarWidth: "none",
                  msOverflowStyle: "none",
                }}
              >
                <Dropdown.Item
                  onClick={() => {
                    setSearchTerm("");
                    handleSelectFiat("ALL");
                    getNewCurrency("ALL");
                  }}
                >
                  ALL
                </Dropdown.Item>
                {newFiatArray.length !== 0 &&
                  newFiatArray?.map((data, i) => (
                    <Dropdown.Item
                      key={i}
                      onClick={() => {
                        setSearchTerm("");
                        handleSelectFiat(data);
                        getNewCurrency(data);
                      }}
                    >
                      {data}
                    </Dropdown.Item>
                  ))}
              </Dropdown.Menu>
            </Dropdown>
            <p />
          </div>
          {loading && (
            <div className="loading style-2">
              <div className="loading-wheel"></div>
            </div>
          )}
          <div
            className="table_content_dropdown"
            style={{ maxHeight: "200px", margin: "4px" }}
          >
            <table>
              <thead style={{ position: "sticky", top: "0", zIndex: 1 }}>
                <th
                  style={{
                    textAlign: "start",
                    backgroundColor: "var(--body-color-less3)",
                  }}
                >
                  Pair
                </th>
                <th
                  style={{
                    textAlign: "center",
                    backgroundColor: "var(--body-color-less3)",
                  }}
                >
                  Last Price
                </th>
                <th style={{ backgroundColor: "var(--body-color-less3)" }}>
                  ROC
                </th>
                <th
                  style={{
                    cursor: "pointer",
                    backgroundColor: "var(--body-color-less3)",
                  }}
                  onClick={handleVolumnToggle}
                >
                  <ImportExportIcon sx={{ fontSize: "16px" }} /> Volume
                </th>
              </thead>
              <tbody style={{ overflowY: "scroll" }}>
                {assetetpairback?.length > 0 ? (
                  assetetpairback?.map((d, i) => (
                    <tr
                      key={`${d?.currencycode}-${d?.basecurrency}-${i}`}
                      onClick={() => {
                        handleCurrencySelect(d);
                        buySellCode(d);
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <td
                        style={{
                          fontWeight: "bold",
                          cursor: "pointer",
                          textAlign: "start",
                          color: theme === "light" ? "rgb(0, 123, 255)" : "",
                          whiteSpace: "nowrap",
                        }}
                      >
                        <span
                          onClick={(e) => toggleFavoritePair(d, e)}
                          style={{
                            cursor: "pointer",
                            marginRight: "6px",
                            color: isPairFavorite(d) ? "#f0b90b" : "rgba(125, 125, 125, 0.45)",
                            fontSize: "13px",
                            display: "inline-block",
                            transition: "all 0.15s ease",
                          }}
                          title={isPairFavorite(d) ? "Remove from Favorites" : "Add to Favorites"}
                        >
                          {isPairFavorite(d) ? "★" : "☆"}
                        </span>
                        <img
                          src={`https://brokersexchange.s3.us-west-1.amazonaws.com/currency_logo/${d?.currencycode}.png`}
                          alt="coin"
                          onError={(e) => {
                            e.target.style.display = "none";
                          }}
                          style={{
                            height: "14px",
                            width: "14px",
                            margin: "5px 3px 5px 0",
                          }}
                        />
                        {d?.currencycode}/{d?.basecurrency}
                      </td>
                      <td className="text-end">
                        <span
                          style={{
                            color:
                              d?.lpricecolor === false
                                ? (downColor || "rgb(255, 0, 122)")
                                : d?.lpricecolor === true
                                  ? (upColor || "rgb(112,168, 0)")
                                  : "rgb(245,245,220)",
                          }}
                        >
                          {d?.lasttrade1} &nbsp;
                        </span>
                        {/* <span style="color:rgb(161, 161, 159);" *ngIf="m.basecurrency=='INR'"> ₹ </span><span
                      style="color:rgb(161, 161, 159);" *ngIf="m.basecurrency =='USD' || m.basecurrency=='USDT'"> $
                    </span><span style="color:rgb(161, 161, 159);" *ngIf="m.basecurrency=='EUR'"> €</span><span
                      style="color:rgb(161, 161, 159);" *ngIf="m.basecurrency=='SGD'">S$</span> */}

                        <span style={{ color: "rgb(161, 161, 159)" }}>
                          /{" "}
                          {d?.basecurrency == "INR"
                            ? " ₹ "
                            : d?.basecurrency == "USD" ||
                              d?.basecurrency == "USDT"
                              ? "$"
                              : d?.basecurrency == "EUR"
                                ? "€"
                                : "S$"}
                        </span>
                        <span style={{ color: "rgb(161, 161, 159)" }}>
                          {d?.lasttrade2}
                        </span>
                      </td>
                      <td
                        style={{
                          color: d?.isRocPositive
                            ? (upColor || "rgb(112,168, 0)")
                            : (downColor || "rgb(255, 0, 122)"),
                        }}
                      >
                        {(Number(d?.roc) || 0).toFixed(2)}
                      </td>
                      <td style={{ color: theme === "light" ? "black" : "" }}>
                        {d?.volume}
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td
                      colSpan="4"
                      style={{
                        textAlign: "center",
                        padding: "20px 10px",
                        color: "var(--text-color)",
                        opacity: 0.7,
                      }}
                    >
                      No pairs found
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
        </div>
      )}
      <div style={{ flex: 1, minHeight: 0, display: "flex", flexDirection: "column", overflow: "hidden" }}>
        <OrderBook />
      </div>
    </div>
  );
};

export default LeftTable;
